export default __webpack_public_path__ + "static/media/novo-login.0ab2a5e6.png";